import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../utils/api';

export const fetchCategories = createAsyncThunk('categories/fetch', async (params, { rejectWithValue }) => {
  try {
    const { data } = await API.get('/categories', { params });
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message);
  }
});

const categorySlice = createSlice({
  name: 'categories',
  initialState: { categories: [], loading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => { state.loading = true; })
      .addCase(fetchCategories.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.categories = payload?.categories || [];
      })
      .addCase(fetchCategories.rejected, (state) => { state.loading = false; });
  },
});

export default categorySlice.reducer;
